/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import useCommonStores from '../../store/useCommonStores';
import useUIStates from '../../store/models/uistates/useUIStates';
import fieldsFactory, { getDataFromCountryCode } from './fieldsFactory';

function useFields (p) {

    const {
        classes,
    } = p;

    const {
        widget,
        translate,
        optins,
        translateWithValues,
        location,
    } = useCommonStores();

    const {
        fieldErrors, 
        subscribersFields,
        setSubscribersFields,
        customValues,
        updateCustomValues,
        optinValues,
        updateOptinValues,
        touched,
        statesStore,
        cursorPositions,
    } = useUIStates();

    const [fields, setFields] = useState(widget.registration_fields);
    const [customFields, setCustomFields] = useState(widget.custom_fields);
    // const [customFields, setCustomFields] = useState(widget.custom_fields);

    useEffect(() => {
        setFields(widget.registration_fields);
        setCustomFields(widget.custom_fields);
        statesStore.createFieldMaps(widget);
        if (location && location?.country_code) {
            const countryData = getDataFromCountryCode(location?.country_code?.toLowerCase());
            setSubscribersFields({
               ...countryData,
            });
        }
    }, [widget.registration_fields]);

    function renderFields () {
        const fieldParams = {
            widget,
            fields,
            fieldErrors,
            classes,
            translate,
            translateWithValues,
            subscribersFields,
            setSubscribersFields,
            touched,
            location,
            statesStore,
            cursorPositions,
        };
        return (
            <React.Fragment>
                { fieldsFactory.render(fieldParams) }
            </React.Fragment>
        );
    }

    function renderCustomFields () {
        const fieldParams = {
            widget,
            fields,
            fieldErrors,
            classes,
            translate,
            translateWithValues,
            customFields,
            customValues,
            updateCustomValues,
            touched,
        };

        return (
            <React.Fragment>
                { fieldsFactory.renderCustomFields(fieldParams) }
            </React.Fragment>
        );
    }

    function renderOptins () {
        const fieldParams = {
            widget,
            fields,
            fieldErrors,
            classes,
            translate,
            translateWithValues,
            optins,
            optinValues,
            updateOptinValues,
            touched,
        };
        return (
            <React.Fragment>
                { fieldsFactory.renderOptins(fieldParams) }
            </React.Fragment>
        );
    }

    return {
        renderFields,
        renderCustomFields,
        renderOptins,
    };
}

export default useFields;